import { useEffect, useState } from 'react';
import { isPlatformAdminEmail } from '../constants/platformAdmin';
import { getSession } from '../services/authService';
import { fetchAmIPlatformManager } from '../services/platformManagerService';

/** 플랫폼 관리자 또는 매니저 — 학습내용·평가계획·범교과 접근 */
export function usePlatformContentEditorAccess(): {
  ready: boolean;
  allowed: boolean;
} {
  const [ready, setReady] = useState(false);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const s = await getSession();
        const email = (s?.user?.email ?? '').trim().toLowerCase();
        if (isPlatformAdminEmail(email)) {
          if (!cancelled) {
            setAllowed(true);
            setReady(true);
          }
          return;
        }
        const manager = await fetchAmIPlatformManager();
        if (!cancelled) {
          setAllowed(manager);
          setReady(true);
        }
      } catch {
        if (!cancelled) {
          setAllowed(false);
          setReady(true);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { ready, allowed };
}
